import { types } from "mobx-state-tree";
import { UserStore as User } from "./UserStore";

export const CommentStore = types
  .model({
    id: types.identifierNumber,
    content: types.maybeNull(types.string),
    image_url: types.maybeNull(types.string),
    thumbnail_url: types.maybeNull(types.string),

    creator: types.maybeNull(User),
    time_elapsed: types.string,

    parent_id: types.maybeNull(types.integer),
    childComments: types.optional(types.array(types.late(() => CommentStore)), []),

    lesson: types.model({
      id: types.maybeNull(types.number),
      name: types.maybeNull(types.string),
    }),

    featured: types.maybeNull(
      types.model({
        status: types.maybeNull(types.enumeration(["inactive", "active"])),
        creator: User,
      }),
    ),

    reacts: types.maybeNull(
      types.array(
        types.model({
          id: types.identifierNumber,
          status: types.maybeNull(types.enumeration(["inactive", "active"])),
          type: types.enumeration(["like", "love", "haha", "wow"]),
          creator: User,
        }),
      ),
    ),

    reaction: types.maybeNull(
      types.model({
        id: types.identifierNumber,
        status: types.maybeNull(types.enumeration(["inactive", "active"])),
        type: types.string,
      }),
    ),
  })
  .views((self) => ({
    get topReaction() {
      if (!self.reacts) return [];

      const reactCount = self.reacts?.reduce(
        (obj, v) => {
          obj[v.type] = (obj[v.type] || 0) + 1;

          return obj;
        },
        {
          like: 0,
          love: 0,
          haha: 0,
          wow: 0,
        },
      );

      let sortable = Object.fromEntries(Object.entries(reactCount).sort(([, a], [, b]) => a - b));
      let keys = Object.keys(sortable);

      delete sortable[keys[0]];
      sortable = Object.fromEntries(Object.entries(sortable).filter(([_, v]) => v !== 0));

      return sortable;
    },
  }))
  .actions((self) => ({
    setFeature(feature) {
      self.featured = feature;
    },

    setReaction(reaction) {
      self.reaction = reaction;
    },

    setReacts(reacts) {
      self.reacts = reacts;
    },
  }));
